// @flow
import SearchBox from './SearchBox';

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/search/SearchBox/index.js